import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Line as DataVizLine, Svg, TargetLine } from '@opengov/data-viz';
import { sortBy, throttle } from 'lodash';
import * as React from 'react';
import { Axis } from '../Axis';
import { AxisName } from '../AxisName';
import { labelFormatter } from '../Chart';
import { DEFAULT_LINE_POINT_INNER_RADIUS, DEFAULT_LINE_POINT_OUTER_RADIUS, DEFAULT_LINE_POINT_TARGET_RADIUS, DEFAULT_Y_AXIS_LABEL_OFFSET } from '../chartUtilities/constants';
import { MessageOverlay } from '../MessageOverlay';
import { TargetStatus } from '../TargetStatus';
import lineStyle from './Line.scss';
import lineHoverStyle from './LineHover.scss';
import pointStyle from './Point.scss';
import pointHoverStyle from './PointHover.scss';
export var Line = /*#__PURE__*/function (_React$Component) {
  _inherits(Line, _React$Component);

  var _super = _createSuper(Line);

  function Line(props) {
    var _this;

    _classCallCheck(this, Line);

    _this = _super.call(this, props);

    _this.measureChartContainer = function (element) {
      _this.chartContainer = element;
    };

    _this.handleChartResize = function () {
      if (_this.props.onChartResize && _this.chartContainer) {
        _this.props.onChartResize(_this.chartContainer.getBoundingClientRect());
      }
    };

    _this.handleXTickFormat = function (dataId) {
      var _this$props = _this.props,
          chartCalculations = _this$props.chartCalculations,
          xTickLabelFormatter = _this$props.xTickLabelFormatter;
      return labelFormatter(xTickLabelFormatter, chartCalculations, dataId);
    };

    _this.handleYTickFormat = function (value) {
      var yTickLabelFormatter = _this.props.yTickLabelFormatter;
      return value !== undefined && yTickLabelFormatter && yTickLabelFormatter(value);
    };

    _this.handlePointEnter = function (category, point, domCoordinate, target) {
      var _this$props2 = _this.props,
          setSelectedCategory = _this$props2.setSelectedCategory,
          setSelectedPoint = _this$props2.setSelectedPoint,
          onPointEnter = _this$props2.onPointEnter;

      if (setSelectedPoint) {
        setSelectedPoint(_objectSpread(_objectSpread({}, point), {}, {
          category: category
        }));
      }

      if (setSelectedCategory) {
        setSelectedCategory(category);
      }

      if (onPointEnter) {
        onPointEnter(category, point, domCoordinate, target);
      }
    };

    _this.handlePointLeave = function (domCoordinate) {
      _this.handleElementLeave();

      if (_this.props.onPointLeave) {
        _this.props.onPointLeave(domCoordinate);
      }
    };

    _this.handleLineEnter = function (category) {
      var setSelectedCategory = _this.props.setSelectedCategory;

      if (setSelectedCategory) {
        setSelectedCategory(category);
      }
    };

    _this.handleElementLeave = function () {
      var _this$props3 = _this.props,
          setSelectedCategory = _this$props3.setSelectedCategory,
          setSelectedPoint = _this$props3.setSelectedPoint;

      if (setSelectedCategory) {
        setSelectedCategory(null);
      }

      if (setSelectedPoint) {
        setSelectedPoint(null);
      }
    };

    _this.classForLineContainer = function (category) {
      var _this$props4 = _this.props,
          selectedCategory = _this$props4.selectedCategory,
          selectedPoint = _this$props4.selectedPoint;
      var inactiveCategory = selectedCategory && category !== selectedCategory;
      var inactivePoint = selectedPoint && category !== selectedPoint.category;

      if (inactiveCategory || inactivePoint) {
        return lineStyle.lineContainer;
      }

      return null;
    };

    _this.styleForLine = function (category) {
      var _this$props5 = _this.props,
          selectedCategory = _this$props5.selectedCategory,
          selectedPoint = _this$props5.selectedPoint;
      var activeCategory = selectedCategory && category === selectedCategory;
      var containsSelectedPoint = selectedPoint && selectedPoint.category === category;

      if (activeCategory || containsSelectedPoint) {
        return lineHoverStyle;
      }

      return lineStyle;
    };

    _this.styleForPoint = function (point) {
      var selectedPoint = _this.props.selectedPoint;

      if (selectedPoint && JSON.stringify(point) === JSON.stringify(selectedPoint)) {
        return pointHoverStyle;
      }

      return pointStyle;
    };

    _this.handleLineClick = function (category) {
      return _this.props.onLineClick(category);
    };

    _this.handlePointClick = function (point) {
      return _this.props.onPointClick(point.category);
    };

    _this.handleChartResize = throttle(_this.handleChartResize, 128);
    return _this;
  }

  _createClass(Line, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleChartResize);
      this.handleChartResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleChartResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          chartCalculations = _this$props6.chartCalculations,
          dataTest = _this$props6.dataTest,
          selectedCategory = _this$props6.selectedCategory,
          xAxisName = _this$props6.xAxisName,
          yAxisName = _this$props6.yAxisName,
          yTickMax = _this$props6.yTickMax,
          onLineClick = _this$props6.onLineClick,
          showOverlay = _this$props6.showOverlay,
          _this$props6$targetSt = _this$props6.targetStatuses,
          targetStatuses = _this$props6$targetSt === void 0 ? [] : _this$props6$targetSt,
          messageOverlayProps = _this$props6.messageOverlayProps,
          elementColorForLine = _this$props6.elementColorForLine,
          elementColorForInnerPoint = _this$props6.elementColorForInnerPoint,
          elementColorForOuterPoint = _this$props6.elementColorForOuterPoint,
          targetValueFormatter = _this$props6.targetValueFormatter;
      var categories = chartCalculations.categories,
          coordinateSystem = chartCalculations.coordinateSystem,
          data = chartCalculations.data,
          dimensions = chartCalculations.dimensions,
          margin = chartCalculations.margin,
          xScale = chartCalculations.xScale,
          yScale = chartCalculations.yScale,
          yTickLabelWidth = chartCalculations.yTickLabelWidth,
          xTickLabelWidth = chartCalculations.xTickLabelWidth;
      var xAxisNameXOffset = -50;
      return React.createElement("div", {
        ref: this.measureChartContainer,
        "data-test": dataTest,
        className: lineStyle.fixedHeight
      }, showOverlay && this.chartContainer && React.createElement(MessageOverlay, Object.assign({}, messageOverlayProps, {
        leftMargin: margin.left + yTickLabelWidth,
        width: this.chartContainer.getBoundingClientRect().width - DEFAULT_Y_AXIS_LABEL_OFFSET - margin.left - yTickLabelWidth
      })), React.createElement(Svg, {
        coordinateSystem: coordinateSystem
      }, React.createElement("g", {
        transform: "translate(".concat(margin.left, ", ").concat(margin.top, ")")
      }, React.createElement("g", {
        className: "y-axis"
      }, React.createElement(AxisName.Y, {
        dimmed: showOverlay,
        text: yAxisName,
        x: xAxisNameXOffset,
        y: 0
      }), React.createElement(Axis.Y, {
        dimmed: showOverlay,
        approximateNumberOfTicks: yTickMax,
        tickLabelFormatter: this.handleYTickFormat,
        xScale: xScale,
        yScale: yScale
      })), React.createElement("g", {
        className: "x-axis"
      }, React.createElement(AxisName.X, {
        dimmed: showOverlay,
        text: xAxisName,
        x: dimensions.width / 2,
        y: dimensions.height + DEFAULT_Y_AXIS_LABEL_OFFSET
      }), React.createElement(Axis.Band.X, {
        dimmed: showOverlay,
        xTickLabelWidth: xTickLabelWidth,
        tickLabelFormatter: this.handleXTickFormat,
        xScale: xScale,
        yScale: yScale
      })), React.createElement(DataVizLine, {
        categories: categories,
        classForLineContainer: this.classForLineContainer,
        colorForInnerPoint: elementColorForInnerPoint,
        colorForLine: elementColorForLine,
        colorForOuterPoint: elementColorForOuterPoint,
        data: data,
        lineStyle: lineStyle,
        onLineClick: onLineClick,
        onLineEnter: this.handleLineEnter,
        onLineLeave: this.handleElementLeave,
        onPointClick: this.handlePointClick,
        onPointEnter: this.handlePointEnter,
        onPointLeave: this.handlePointLeave,
        pointInnerRadius: DEFAULT_LINE_POINT_INNER_RADIUS,
        pointOuterRadius: DEFAULT_LINE_POINT_OUTER_RADIUS,
        pointTargetRadius: DEFAULT_LINE_POINT_TARGET_RADIUS,
        selectedCategory: selectedCategory,
        styleForLine: this.styleForLine,
        styleForPoint: this.styleForPoint,
        xScale: xScale,
        yScale: yScale
      }), React.createElement("g", {
        className: "targets",
        "data-test": "targets"
      }, sortBy(targetStatuses, function (s) {
        return s.value;
      }).map(function (target, index) {
        var scaleValue = yScale(target.value);
        return React.createElement("g", {
          className: "target",
          key: "target-".concat(target.operator, "-").concat(target.value)
        }, React.createElement(TargetLine, {
          style: lineStyle.targetLine,
          orientation: "vertical",
          value: scaleValue,
          dimensions: dimensions
        }), React.createElement(TargetStatus, {
          dataTest: "target-status-".concat(index),
          verticalAlignment: targetStatuses.length > 1 ? index > 0 ? 'top' : 'bottom' : 'middle',
          config: target,
          x: dimensions.width + 8,
          y: scaleValue,
          valueFormatter: targetValueFormatter
        }));
      })))));
    }
  }]);

  return Line;
}(React.Component);